import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../context/crmContext";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import loginLogo from "../../../assets/loginLogo.png";
import logOutIcon from "../../../assets/logout.png";
import userIcon from "../../../assets/userIcon.png";
import searchIcon from "../../../assets/searchIcon.png";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import action from "../action";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import styles from "../../dashboard/Operations/dashboard.css";
import { addNewOperationsTableHeader } from "../../../constants/Constants";
import Tooltip from "@mui/material/Tooltip";
import addIcon from "../../../assets/addIcon.png";
import AddDetailsModal from "../Operations/AddDetailsModal";
import Pagination from "@mui/material/Pagination";
import { formatDate } from "../../../common/Common";
import CRMlogo from "../../../assets/CRM.png";
// import RenewalDetailsModal from "../Renewal/RenewalDetailsModal";
import CustomerCareModal from "../CustomerCare/CustomerCareModal";
import CustomerCareAddFilters from "./AddFilters";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ff867a",
    },
  },
});

const AddCustomerCareUser = () => {
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const {
    user: { fname, mname, lname, email },
    userEmail,
    setSnackBarState,
    setIsLoader,
  } = context;
  const [searchedDocName, setSearchedDocName] = useState("");
  const [searchedDocId, setSearchedDocId] = useState(null);
  const [searchedClinicId, setSearchedClinicId] = useState(null);
  const [listingData, setlistingData] = useState({});
  const { getSearchResponse, getUserDetails } = action;
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [isOpenAddFilters, setIsOpenAddFilters] = useState(false);

  const logoutUser = () => {
    navigate("/");
  };

  useEffect(() => {
    getSearchResult();
  }, [page]);

  useEffect(() => {
    getUserDetails(localStorage.getItem("accessToken"), userDetails);
  }, []);

  const userDetails = (details) => {
    if (details?.statusCode === 200 && details?.result) {
      context.setUser(details?.result?.userDetails);
    }
  };

  const getSearchedValue = (e, key) => {
    if (key === "docName") {
      setSearchedDocName(() => e.target.value);
    }

    if (key === "docID") {
      setSearchedDocId(() => e.target.value);
    }

    if (key === "clinicId") {
      setSearchedClinicId(() => e.target.value);
    }
  };

  const getSearchResult = (data) => {
    setIsLoader(() => true);
    try {
      const payload = {
        doctorname: data.docName,
        doctorid: Number(data.docID) || null,
        clinicid: Number(data.clinicId) || null,
        email: data.email,
        mobile: Number(data.phone),
        page: page,
        size: size,
      };
      getSearchResponse(payload, getData);
    } catch (error) {
      console.log("error in getsearchresult", error);
    }
    setIsOpenAddFilters(() => false);
    setIsLoader(() => false);
  };

  const getData = (data) => {
    if (data?.statusCode === 200) {
      setlistingData(() => data?.result?.doctors);
    }
    context.setSnackBarState({
      isOpen: true,
      message: data?.message,
      statusCode: data?.statusCode,
    });
  };

  const openAddModal = (data) => {
    setSelectedDetails(() => data);
    setIsAddModalOpen(() => true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(() => false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(() => newPage);
  };

  const openAddFilters = () => {
    setIsOpenAddFilters(() => true);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Container
          fixed
          style={{
            width: "100%",
            height: "100%",
            margin: "0px",
            position: "absolute",
            top: "0",
            left: "0",
            minWidth: "100%",
          }}
        >
          <img
            src={CRMlogo}
            style={{
              position: "absolute",
              top: "89%",
              left: "94%",
              zIndex: 1,
              height: "60px",
            }}
          />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            style={{
              position: "absolute",
              left: "0px",
              height: "10%",
              alignItems: "center",
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
            }}
          >
            <img
              src={loginLogo}
              style={{ height: "7vh", paddingLeft: "20px" }}
            />

            <Grid
              style={{
                background: "#f0f1f5",
                marginRight: "4%",
                width: "15%",
                borderRadius: "15px",
                display: "inline-flex",
                alignItems: "center",
              }}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <img
                src={userIcon}
                style={{ height: "40px", width: "40px", marginLeft: "5px" }}
              />
              <span
                style={{
                  color: "#7d7d7d",
                  width: "50%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {email}
              </span>
              <div
                style={{
                  background: "white",
                  borderRadius: "25px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "-10px",
                  cursor: "pointer",
                  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.16)",
                }}
                onClick={() => logoutUser()}
              >
                <img
                  src={logOutIcon}
                  style={{ height: "22px", width: "22px", padding: "15px" }}
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            style={{
              background: "#f5f5f5",
              position: "absolute",
              left: "0px",
              top: "10%",
              height: "90%",
            }}
          >
            <Grid
              style={{
                position: "relative",
                background: "white",
                height: "94%",
                top: "3%",
                marginLeft: "1%",
                width: "100%",
                marginRight: "1%",
                boxShadow: "4px 4px 8px 0 rgba(0, 0, 0, 0.06)",
                borderRadius: "10px",
              }}
            >
              <Grid
                style={{
                  textAlign: "end",
                  marginTop: "5vh",
                  marginRight: "5vh",
                }}
              >
                <CustomerCareAddFilters
                  open={isOpenAddFilters}
                  handleFilterModalClose={() =>
                    setIsOpenAddFilters(() => false)
                  }
                  filterSearchedData={getSearchResult}
                />
                <Button
                  variant="outlined"
                  style={{
                    border: "1px solid #f0f1f5",
                    background: "#f0f1f5",
                    color: "#afafaf",
                    padding: "8px",
                  }}
                  onClick={() => openAddFilters()}
                >
                  Filters & Search
                </Button>
                {/* <TextField
                  variant="standard"
                  id="outlined-start-adornment"
                  style={{ background: "#f0f1f5", borderRadius: "10px" }}
                  placeholder="Doctor Name"
                  sx={{
                    m: 1,
                    width: "40ch",

                    justifyContent: "center",

                    padding: "5px",
                  }}
                  onChange={(e) => getSearchedValue(e, "docName")}
                  value={searchedDocName}
                  InputProps={{
                    startAdornment: (
                      <img
                        src={searchIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          padding: "5px",
                        }}
                      />
                    ),
                    disableUnderline: true,
                  }}
                  size="small"
                />
                <TextField
                  variant="standard"
                  id="outlined-start-adornment"
                  style={{ background: "#f0f1f5", borderRadius: "10px" }}
                  placeholder="Doctor ID"
                  sx={{
                    m: 1,
                    width: "40ch",

                    justifyContent: "center",

                    padding: "5px",
                  }}
                  onChange={(e) => getSearchedValue(e, "docID")}
                  value={searchedDocId}
                  InputProps={{
                    startAdornment: (
                      <img
                        src={searchIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          padding: "5px",
                        }}
                      />
                    ),
                    disableUnderline: true,
                  }}
                  size="small"
                />
                <TextField
                  variant="standard"
                  id="outlined-start-adornment"
                  style={{ background: "#f0f1f5", borderRadius: "10px" }}
                  placeholder="Clinic ID"
                  sx={{
                    m: 1,
                    width: "40ch",

                    justifyContent: "center",

                    padding: "5px",
                  }}
                  onChange={(e) => getSearchedValue(e, "clinicId")}
                  value={searchedClinicId}
                  InputProps={{
                    startAdornment: (
                      <img
                        src={searchIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          padding: "5px",
                        }}
                      />
                    ),
                    disableUnderline: true,
                  }}
                  size="small"
                /> */}
                {/* <Button
                  variant="outlined"
                  size="large"
                  style={{
                    marginTop: "6px",
                    marginLeft: "10px",
                    borderRadius: "25px",
                  }}
                  onClick={() => getSearchResult()}
                >
                  Search
                </Button> */}
              </Grid>
              <Grid style={{ height: "60%", marginTop: "3vh" }}>
                <TableContainer
                  className={styles.root}
                  style={{
                    width: "96%",
                    marginLeft: "2%",
                    borderDadius: "10px",
                    overflow: "auto",
                    minWidth: "80%",
                  }}
                >
                  <Table
                    className={styles.table}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "0.05vw solid rgba(224; 224; 224; 1)",
                    }}
                    size="medium"
                    aria-label="a dense table"
                  >
                    <TableHead className="tableHead">
                      <TableRow>
                        {addNewOperationsTableHeader.map((header, index) => (
                          <TableCell
                            className={styles.header}
                            style={{
                              color: "white",
                              fontFamily: "Lato",
                              fontSize: "16px",
                              fontWeight: "bold",
                              fontStretch: "normal",
                              fontStyle: "normal",
                              lineHeight: "1.33",
                              letterSpacing: "normal",
                              textAlign: "left",
                              color: "#FFFFFF",
                              zIndex: "20",
                              width: "10%",
                              maxWidth: "10%",
                            }}
                            key={index}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
                <TableContainer
                  className={styles.root}
                  style={{
                    width: "96%",
                    marginLeft: "2%",
                    height: "100%",
                    maxHeight: "100%",
                    overFlow: "auto",
                  }}
                >
                  <Table
                    className={styles.table}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "0.05vw solid rgba(224; 224; 224; 1)",
                    }}
                    size="medium"
                    aria-label="a dense table"
                    stickyHeader
                  >
                    {listingData?.doctors?.length > 0 ? (
                      <TableBody className={styles.tableBody}>
                        {listingData?.doctors?.map((e, index) => (
                          <>
                            <TableRow
                              className={styles.tableRow}
                              style={{ height: "3rem" }}
                              key={1}
                            >
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <Tooltip
                                  title={e.doctorid}
                                  arrow
                                  placement="top"
                                >
                                  <span>{`${e.doctorid}`}</span>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                {e.clinicid}
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                {e.doctorname}
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                {/* <Tooltip title={e.doctorname} arrow placement="top"> */}
                                <span>{e.clinicrole}</span>
                                {/* </Tooltip> */}
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <Tooltip
                                  title={e.clinicname}
                                  arrow
                                  placement="top"
                                >
                                  <span>{e.clinicname}</span>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                {e.totalappointments}
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <Tooltip
                                  title={formatDate(e.lastappointmentdate)}
                                  arrow
                                  placement="top"
                                >
                                  <span>
                                    {formatDate(e.lastappointmentdate)}
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                {/* <Tooltip title={e.starttime} arrow placement="top"> */}
                                <span>{e.totalprescriptions}</span>
                                {/* </Tooltip> */}
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <Tooltip
                                  title={formatDate(e.lastprescriptiondate)}
                                  arrow
                                  placement="top"
                                >
                                  <span>
                                    {formatDate(e.lastprescriptiondate)}
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                className={styles.body}
                                style={{
                                  fontFamily: "Lato",
                                  fontSize: "0.64",
                                  fontStretch: "normal",
                                  fontStyle: "normal",
                                  lineHeight: "1.33",
                                  letterSpacing: "normal",
                                  textAlign: "left",
                                  color: "#2e2e2e",
                                  width: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "100px",
                                }}
                              >
                                <img
                                  src={addIcon}
                                  style={{
                                    height: "16px",
                                    width: "16px",
                                    cursor: "pointer",
                                    // marginRight: "5px",
                                  }}
                                  onClick={() => openAddModal(e)}
                                />
                              </TableCell>
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          marginTop: "10vh",
                          fontWeight: "bold",
                        }}
                      >
                        No Data Available
                      </p>
                    )}
                  </Table>
                </TableContainer>
                {listingData?.doctors?.length > 0 && (
                  <div style={{ paddingTop: "20px", paddingLeft: "30px" }}>
                    <ThemeProvider theme={theme}>
                      <Pagination
                        count={Math.round(listingData?.totalRecords / size + 1)}
                        color="primary"
                        style={{ color: "white" }}
                        onChange={handleChangePage}
                      />
                    </ThemeProvider>
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </ThemeProvider>
      {
        isAddModalOpen && (
          // (localStorage.getItem("userRole") === "Operations" ? (
          //   <AddDetailsModal
          //     isAddModalOpen={isAddModalOpen}
          //     closeAddModal={closeAddModal}
          //     headerLabel={"Add Details"}
          //     selectedDetails={selectedDetails}
          //   />
          // ) : localStorage.getItem("userRole") === "Customer Care" ? (
          <CustomerCareModal
            isAddModalOpen={isAddModalOpen}
            closeAddModal={closeAddModal}
            headerLabel={"Add Details"}
            selectedDetails={selectedDetails}
          />
        )
        // ) : (
        //   <RenewalDetailsModal
        //     isAddModalOpen={isAddModalOpen}
        //     closeAddModal={closeAddModal}
        //     headerLabel={"Add Details"}
        //     selectedDetails={selectedDetails}
        //   />
        // ))
      }
    </>
  );
};
export default AddCustomerCareUser;
